import { useEffect, useState } from "react";
import Library from "../components/Library";
import useAuth from "../../Users/hooks/useAuth";
import Login from "../../Users/Login";
import ForgotPassword from "../../Users/ForgotPw";
import Register from "../../Users/Register";

const guestUser = {
  username: "guest",
  email: null,
  role: "guest",
  isGuest: true,
};

const Entry = () => {
  const { auth, setAuth } = useAuth();

  const [authChecked, setAuthChecked] = useState(false);
  const [showAuthOverlay, setShowAuthOverlay] = useState(false);
  const [forgotPass, setForgotPass] = useState(false);
  const [register, setRegister] = useState(false);

  const isGuest =
    !auth?.email || auth?.username === "guest" || auth?.isGuest === true;

  const checkToken = async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      setAuth(guestUser);
      setAuthChecked(true);
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_USER_API_URL}/users/me`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        const userData = await response.json();

        setAuth({
          ...userData,
          token,
          isGuest: false,
        });
      } else {
        localStorage.removeItem("token");
        setAuth(guestUser);
      }
    } catch (error) {
      console.error("Could not check auth token:", error);
      localStorage.removeItem("token");
      setAuth(guestUser);
    } finally {
      setAuthChecked(true);
    }
  };

  useEffect(() => {
    checkToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (auth?.email && !auth?.isGuest) {
      setShowAuthOverlay(false);
      setRegister(false);
      setForgotPass(false);
    }
  }, [auth?.email, auth?.isGuest]);

  const openLogin = () => {
    setRegister(false);
    setForgotPass(false);
    setShowAuthOverlay(true);
  };

  const openRegister = () => {
    setRegister(true);
    setForgotPass(false);
    setShowAuthOverlay(true);
  };

  const closeOverlay = () => {
    setShowAuthOverlay(false);
    setRegister(false);
    setForgotPass(false);
  };

  if (!authChecked) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50">
        <div className="rounded-[28px] border border-slate-200 bg-white px-6 py-5 text-sm font-black text-slate-500 shadow-sm">
          Loading Catchphraser…
        </div>
      </div>
    );
  }

  return (
    <div className="relative min-h-screen bg-white">
      <Library
        isGuest={isGuest}
        onRequireLogin={openLogin}
        onRegister={openRegister}
      />

      {isGuest && showAuthOverlay && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-950/50 px-4 py-6 backdrop-blur-sm">
          <div className="relative w-full max-w-md overflow-hidden rounded-[2rem] border border-white/70 bg-white shadow-2xl shadow-slate-950/25">
            <div className="absolute -right-12 -top-12 h-36 w-36 rounded-full bg-blue-200/40 blur-3xl" />
            <div className="absolute -bottom-14 left-6 h-32 w-32 rounded-full bg-violet-200/40 blur-3xl" />

            <div className="relative p-6">
              <button
                type="button"
                onClick={closeOverlay}
                className="absolute right-4 top-4 flex h-9 w-9 items-center justify-center rounded-full bg-slate-100 text-lg font-black text-slate-500 transition hover:bg-slate-200 hover:text-slate-950"
                aria-label="Close login window"
              >
                ×
              </button>

              <div className="mb-5 pr-10">
                <div className="text-[11px] font-black uppercase tracking-[0.2em] text-blue-600">
                  The Catchphraser
                </div>

                <h2 className="mt-2 text-2xl font-black tracking-tight text-slate-950">
                  {register
                    ? "Create your account"
                    : forgotPass
                      ? "Reset password"
                      : "Sign in to personalize"}
                </h2>

                <p className="mt-2 text-sm font-semibold leading-6 text-slate-500">
                  {register
                    ? "Save recordings, track progress, request feedback, and continue your practice across devices."
                    : forgotPass
                      ? "Enter your account details to recover access."
                      : "You can explore as a guest. Sign in when you want Catchphraser to remember your work."}
                </p>
              </div>

              <div className="rounded-[1.5rem] border border-slate-100 bg-slate-50/80 p-4">
                {register ? (
                  <Register
                    successHandler={(state) => {
                      setRegister(state);
                      setForgotPass(false);
                    }}
                  />
                ) : forgotPass ? (
                  <ForgotPassword
                    forgotPassHandler={(state) => {
                      setForgotPass(state);
                      setRegister(false);
                    }}
                  />
                ) : (
                  <Login
                    forgotPassHandler={(state) => {
                      setForgotPass(state);
                      setRegister(false);
                    }}
                    registerHandler={(state) => {
                      setRegister(state);
                      setForgotPass(false);
                    }}
                  />
                )}
              </div>

              <button
                type="button"
                onClick={closeOverlay}
                className="mt-4 w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-black text-slate-700 shadow-sm transition hover:-translate-y-0.5 hover:bg-slate-50"
              >
                Continue exploring as guest
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Entry;